ready(function(){


  // -- mobile menu --
  // ------------------	

	var menuBtn = document.querySelector('.header__menu__btn');

	if (!menuBtn) {
		return;
	}

	menuBtn.addEventListener('click', function() {
		if (menuBtn.classList.contains('active')) {
			menuBtn.classList.remove('active');
			document.body.classList.remove('menu--active');
		} else {
			menuBtn.classList.add('active');
			document.body.classList.add('menu--active');
		}
	});

  // -- reset open menu (mobile) --
  ['resize','orientationchange'].forEach(function(eventType){
    window.addEventListener(eventType, (e) => {
    	if (window.innerWidth >= 768) {    		
				menuBtn.classList.remove('active');
				document.body.classList.remove('menu--active');
    	}
    });
  });	

});
